import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [venue, setVenue] = useState(null);
  const [openDays, setOpenDays] = useState(null);
  const [openedAt, setOpenedAt] = useState(null);
  const [closedAt, setClosedAt] = useState(null);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [expo, setExpo] = useState(0);
  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [cinemaStatus, setEventStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const [pricing, setPricing] = useState([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);
  const [payLink, setPayLink] = useState(null);

  const eventRoutes = "/data/cinema";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setVenue(null);
    setExpo(0);
    setOpenDays(null);
    setOpenedAt(null);
    setClosedAt(null);
    setEmail(null);
    setPayLink(null);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress(null);
    setFeatured(0);
    setDescription(null);
    setPricing([]);
  };

  const responses = (isErr, msg) => {
    setError(isErr);
    setLoading(false);
    setSuccess(!isErr);
    setErrorMessage(msg);
  };

  const addOneEventHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      venue: venue,
      open_days: openDays,
      opened_at: openedAt,
      closed_at: closedAt,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_ad: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: cinemaStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      pricing: pricing,
      pay_link: payLink,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.CINEMA,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-5 sm:p-6";
  const btnBase =
    "inline-flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: eventRoutes }} />
        </div>

        <div className="mb-6">
          <DashboardIntro props={{ intro: `Add Cinema`, name: entry_label }} />
        </div>

        {showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null}

        <form onSubmit={addOneEventHandler} className="space-y-6">
          <div className={`${card} ${sectionPad}`}>
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder(country_name, FOLDERS.CINEMA)}
            />
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Cinema Details" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  required: true,
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "venue",
                  title: "Venue",
                  type: "text",
                  value: venue ? venue : "",
                  onChange: (e) => {
                    setVenue(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "formatted_address",
                  title: "Formatted Address",
                  type: "address",
                  value: formattedAddress ? formattedAddress : "",
                  onChange: (e) => {
                    setFormattedAddress(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Date & Time" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <InputField
                props={{
                  id: "open_days",
                  title: "Open Days",
                  type: "text",
                  value: openDays ? openDays : "",
                  onChange: (e) => {
                    setOpenDays(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "opened_at",
                  title: "Opened At",
                  type: "time",
                  value: openedAt ? openedAt : "",
                  onChange: (e) => {
                    setOpenedAt(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "closed_at",
                  title: "Closed At",
                  type: "time",
                  value: closedAt ? closedAt : "",
                  onChange: (e) => {
                    setClosedAt(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Pricing" }} />
            <Pricing pricing={pricing} setPricing={setPricing} />
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <div className="flex justify-center items-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Social Contact" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp ? whatsapp : "",
                  onChange: (e) => {
                    setWhatsapp(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Facebook",
                  type: "text",
                  value: facebook ? facebook : "",
                  onChange: (e) => {
                    setFacebook(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter ? twitter : "",
                  onChange: (e) => {
                    setTwitter(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram ? instagram : "",
                  onChange: (e) => {
                    setInstagram(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube ? youtube : "",
                  onChange: (e) => {
                    setYoutube(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "Geo Position" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "google_map_code",
                  title: "Google Map Code",
                  type: "text",
                  value: googleMapCode ? googleMapCode : "",
                  onChange: (e) => {
                    setGoogleMapCode(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "latitude",
                  title: "Latitude",
                  type: "text",
                  value: latitude ? latitude : "",
                  onChange: (e) => {
                    setLatitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "longitude",
                  title: "Longitude",
                  type: "text",
                  value: longitude ? longitude : "",
                  onChange: (e) => {
                    setLongitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <Title props={{ title: "More Settings" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <Select
                props={{
                  id: "event_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setEventStatus(1);
                    else setEventStatus(0);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "featured",
                  title: "Featured",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setFeatured(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    const choice = e.target.value;
                    setExpo(choice === "no" ? 0 : 1);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad} space-y-4`}>
            <div className="flex justify-between items-center">
              <Title props={{ title: "Description" }} />
              <MyButton
                onClick={() => setShowDescriptionModal(true)}
                className={`${btnBase} ${btnPrimary}`}
              >
                Generate Description
              </MyButton>
            </div>
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                value: description ? description : "",
                onChange: (e) => {
                  setDescription(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags ? hashtags : "",
                  onChange: (e) => {
                    setHashtags(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className="flex items-center justify-end">
            <MyActionButton
              loading={loading}
              title="Add Cinema"
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;
